import { NotFoundContentMui as NotFoundContent } from '@spotify/confidence-core-react';

import { PageMui as Page } from '../Page';
import { notFoundRouteRef } from './notFoundRoute';

export const NotFoundPage = () => (
  <Page.Root routeRef={notFoundRouteRef} title={null}>
    <Page.Content>
      <NotFoundContent />
    </Page.Content>
  </Page.Root>
);
